import React, { Component } from 'react';
import marker from '../Images/marker.png'; 
import './ImageWithMarker.css';

var Promise = require('es6-promise').Promise;

// location of excact marker point on marker image (relative %)
const markerPointX = 50;
const markerPointY = 96;

export class ImageWithMarker extends Component {
    displayName = ImageWithMarker.name

    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            y: 0
        }
    }

    componentDidMount() {
        // calculate new marker position
        setTimeout(() => {
            this.calcRelativeToAbsolutePosition(this.props.markerX, this.props.markerY);
          }, 0);
        
        window.addEventListener("resize", this.updateDimensions);
    }

    updateDimensions = () => {
        this.calcRelativeToAbsolutePosition(this.props.markerX, this.props.markerY);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    componentWillReceiveProps(nextProps) {
        this.calcRelativeToAbsolutePosition(nextProps.markerX, nextProps.markerY);
    }

    async calcRelativeToAbsolutePosition(relX, relY) {
     
        while (this.refs.imageRef.clientWidth <= 0 || this.refs.imageRef.clientHeight <= 0) {
            console.log('waiting for image to have width and height...');
            await sleep(100);
        }

        while (this.refs.markerRef.clientWidth <= 0 || this.refs.markerRef.clientHeight <= 0) {
            console.log('waiting for marker to have width and height...');
            await sleep(100);
        }

        let imageRef = this.refs.imageRef;
        let imageWidth = imageRef.clientWidth;
        let imageHeight = imageRef.clientHeight;

        let markerRef = this.refs.markerRef;
        let markerWidth = markerRef.clientWidth;
        let markerHeight = markerRef.clientHeight;

        this.setState( {
            x: (imageWidth * relX / 100) - (markerPointX * markerWidth / 100),
            y: (imageHeight * relY / 100) - (markerPointY * markerHeight / 100)
        });
        
    }

     //        //must wait for image to load to determine size
        //        console.log('imageRef.width()=' + imageRef.width() + 'imageRef.height()=' + imageRef.height() + ', x=' + roomData.room.location.x + ', y=' + roomData.room.location.y + ', marker.width()=' + marker.width());
        //        imageRef.show();
        //        marker.css('left', (imageRef.width() * roomData.room.location.x / 100) - (markerPointX * marker.width() / 100)).css('top', (imageRef.height() * roomData.room.location.y / 100) - (markerPointY * marker.height() / 100)).show();
        //    });
   

    render() {
        return (
        <div className="thumbnail">
            <div className="imageMapWrapper"  >
                <img id="imageRef" ref="imageRef" src={this.props.url} alt=""/>
                <img src={marker} id="marker" ref="markerRef" alt="marker" style={{left: this.state.x, top: this.state.y }} />
            </div>
        </div>
        )
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}